import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">快速了解牛牛影视</p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}